/**
 *
 * Hint
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Modal from 'components/Modal/Modal';
import ToolIcon from 'components/Icons/ToolIcon';

import closeButtonSmallWhite from 'assets/icons/closebutton_small_white.svg';
import questionmark from 'assets/allIcons/icons/icon_ui_questionmark.svg';
import EditButton from 'commonStyles/EditButton';

import Body from './styles/Body';
import CloseIconStyles from './styles/CloseIconStyles';
import HintWrapper from './styles/HintWrapper';
import HintButtonStyles from './styles/HintButtonStyles';
import HintIconStyles from './styles/HintIconStyles';
import Title from './styles/Title';

import { selectModal } from 'components/Modal/ModalController/selectors';
import { setModalOptions } from 'components/Modal/ModalController/actions';

class Hint extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      isModalOpen: false
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal() {
    const { dispatchSetModalOptions } = this.props;

    this.setState({ isModalOpen: true }, () => {
      dispatchSetModalOptions({ disableOnClickOutside: true });
    });
  }

  handleCloseModal() {
    const { dispatchSetModalOptions } = this.props;

    this.setState({ isModalOpen: false }, () => {
      dispatchSetModalOptions({ disableOnClickOutside: false });
    });
  }

  render() {
    const { message } = this.props;
    const { isModalOpen } = this.state;

    const { body, title } = message;

    return (
      <HintWrapper>
        <EditButton
          thisStyles={HintButtonStyles}
          onClick={this.handleOpenModal}
        >
          <ToolIcon
            icon={questionmark}
            isSmall={true}
            thisStyles={HintIconStyles}
          />
        </EditButton>
        <Modal
          isOpen={isModalOpen}
          width={'600px'}
          requestClose={this.handleCloseModal}
        >
          <ToolIcon
            onClick={this.handleCloseModal}
            icon={closeButtonSmallWhite}
            thisStyles={CloseIconStyles}
          />
          {title && <Title>{title}</Title>}
          {body && <Body dangerouslySetInnerHTML={{ __html: body }} />}
        </Modal>
      </HintWrapper>
    );
  }
}

const propTypes = {
  dispatchSetModalOptions: PropTypes.func,
  message: PropTypes.shape({
    body: PropTypes.string,
    title: PropTypes.string
  })
};

const mapStateToProps = createStructuredSelector({
  modal: selectModal()
});

function mapDispatchToProps(dispatch) {
  return {
    dispatchSetModalOptions: payload => dispatch(setModalOptions(payload))
  };
}

Hint.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(Hint);
